import {all, fork, put, takeLatest} from "redux-saga/effects";
import {
  createTagSuccess,
  deleteTagSuccess,
  getTagsSuccess,
  getTagSuccess,
  setLoadingInvisible,
  setLoadingVisible,
  updateTagSuccess
} from "redux/actions";
import {TAGS_ALL, TAGS_CREATE, TAGS_DELETE, TAGS_GET, TAGS_UPDATE} from "redux/constants/Tags"
import EstService from "services/EstService"

export function* getTags() {
  yield takeLatest(TAGS_ALL, function* () {
    try {
      const tags = yield EstService.getTags();
      yield put(getTagsSuccess(tags.data));
    } catch (err) {
      console.log(err)
    }
  })
}

export function* getTag() {
  yield takeLatest(TAGS_GET, function* ({tagId}) {
    try {
      const tag = yield EstService.getTag(tagId);
      yield put(getTagSuccess(tag.data));
    } catch (err) {
      console.log(err)
    }
  })
}

export function* createTag() {
  yield takeLatest(TAGS_CREATE, function* ({data, history}) {
    try {
      const tag = yield EstService.createTag(data);
      yield put(createTagSuccess(tag.data));
      history.push(`/app/tags/${tag.data.account_tag_id}`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* updateTag() {
  yield takeLatest(TAGS_UPDATE, function* ({tagId, data, history}) {
    try {
      const tag = yield EstService.updateTag(tagId, data);
      yield put(updateTagSuccess(tagId, tag.data));
      history.push(`/app/tags/${tag.data.account_tag_id}`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* deleteTag() {
  yield takeLatest(TAGS_DELETE, function* ({tagId, history}) {
    try {
      yield put(setLoadingVisible());
      yield EstService.deleteTag(tagId);
      yield put(deleteTagSuccess(tagId));
      yield put(setLoadingInvisible());
      history.push(`/app/tags`);
    } catch (err) {
      console.log(err)
      yield put(setLoadingInvisible());
    }
  })
}

export default function* tagsSaga() {
  yield all([
    fork(getTags),
    fork(createTag),
    fork(getTag),
    fork(updateTag),
    fork(deleteTag),
  ]);
}